/**
 * L'Etape 26 – Main entry point
 *
 * Built via theme's Gulp pipeline (manifest.json).
 */
(function ($) {
    'use strict';

    if ($('body').hasClass('letape26')) {
        window.ys.letape26 = new LEtape26();
    }
}).bind(window)(jQuery);
